import { Component, OnInit, Inject, OnDestroy } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material";
import { Subject } from "rxjs";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ToastrService } from "ngx-toastr";

export interface addRegionSiteDialogData {
  customerId: number;
  formType: "ADD_REGION" | "ADD_SITE";
  availableRegions?: any[]; // For site creation
}

export interface AddRegionSiteResult {
  name: string;
  customerId: number;
  regionId?: number;
  type: "region" | "site";
}

@Component({
  selector: "add-region-or-site-dialog",
  templateUrl: "./add-region-or-site-dialog.component.html",
  styleUrls: ["./add-region-or-site-dialog.component.scss"],
})
export class AddRegionOrSiteDialogComponent implements OnInit, OnDestroy {
  regionSiteCreateForm: FormGroup;
  loading = false;
  availableRegions: any[] = [];
  private destroy$ = new Subject<void>();

  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog,
    private toastr: ToastrService,
    private dialogRef: MatDialogRef<AddRegionOrSiteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: addRegionSiteDialogData
  ) {
    this.createForm();
  }

  ngOnInit(): void {
    if (this.data.formType === "ADD_SITE" && this.data.availableRegions) {
      this.availableRegions = this.data.availableRegions;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private createForm(): void {
    if (this.data.formType === "ADD_REGION") {
      this.regionSiteCreateForm = this.fb.group({
        name: ["", [Validators.required, Validators.minLength(3)]],
      });
    } else {
      this.regionSiteCreateForm = this.fb.group({
        name: ["", [Validators.required, Validators.minLength(3)]],
        regionId: ["", Validators.required],
      });
    }
  }

  getDialogTitle(): string {
    return this.data.formType === "ADD_REGION"
      ? "Add New Region"
      : "Add New Site";
  }

  getNameLabel(): string {
    return this.data.formType === "ADD_REGION" ? "Region Name" : "Site Name";
  }

  getNamePlaceholder(): string {
    return this.data.formType === "ADD_REGION"
      ? "Enter region name"
      : "Enter site name";
  }

  getSubmitLabel(): string {
    return this.data.formType === "ADD_REGION" ? "Add Region" : "Add Site";
  }

  onSubmit(): void {
    if (this.regionSiteCreateForm.valid) {
      this.loading = true;

      const formData = this.regionSiteCreateForm.value;
      const type = this.data.formType === "ADD_REGION" ? "region" : "site";

      
      const result: AddRegionSiteResult = {
        name: formData.name,
        customerId: this.data.customerId,
        type: type,
      };

      if(type === "site") {
        result.regionId = formData.regionId;
      }
      
      this.dialogRef.close(result);
    }
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }
}
